import type EnType from '../en-US/environment';

export default {
  'environment.manageModal.title': 'パーソナル変数',
  'environmentDetail.label.server': 'Base URL',
  'environmentDetail.label.variables': '変数',
  'environmentDetail.label.variables.tips':
    'APIをデバッグする際に変数を使用して、異なるAPI間で同じパラメータ値を再利用できます。変数の形式は {{var_name}} です。',
  'environment.title.variableName': '変数名',
  'environment.title.variableName.placeholder': '変数を追加',
  'environment.title.value': '変数値',
  'environment.title.addVariableValue': '変数を追加',
  'environment.title.serviceName': 'サービス名',
  variableNameEmptyError: '変数名を入力してください',
  preFixUrl: 'Base URL',
  'editor.tip': 'データ形式に従ってください',
  filedBulkEdit: '一括編集',
  'environment.manageModal.tip':
    'ここで設定されたデータはローカルブラウザにのみ保存され、クラウドには同期されません。',
  'environment.manageModal.tip.clickToSetVariable':
    '変数を設定するには、クリックしてください：{variableName}（現在の値：{variableValue}）',
  'baseURL.colon': 'Base URL：',
  'environment.variable.notSet': '未設定',
  byComma: 'カンマ区切り',
  byColon: 'コロン区切り',
} satisfies typeof EnType;
